import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { toCamel, toSnake } from 'convert-keys';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { resetUUID } from '@helper';

@Injectable()
export class GenericOldService<T> {
  apiLocation: string;

  constructor(private httpClient: HttpClient) {
    this.apiLocation = '/api/v1';
  }

  private static handleError(error: string): Observable<never> {
    return throwError(() => {
      return new Error(`${error}`);
    });
  }

  get(path: string, params?: HttpParams, mappingCallback?: (response: unknown) => T): Observable<T> {
    return this.httpClient.get<T>(`${this.apiLocation}/${path}`, { params }).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  getById(
    path: string,
    id: string | number,
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient.get<T>(`${this.apiLocation}/${path}/${id}`, { params }).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  post(
    path: string,
    resource: T | Partial<T>,
    params?: HttpParams,
    mappingCallback?: (response: unknown) => T,
  ): Observable<T> {
    return this.httpClient
      .post<T>(`${this.apiLocation}/${path}`, resource, {
        params,
      })
      .pipe(
        map(item => this.mapResponse(item, mappingCallback)),
        catchError(GenericOldService.handleError),
      );
  }

  delete(path: string, mappingCallback?: (response: unknown) => T): Observable<T> {
    return this.httpClient.delete<T>(`${this.apiLocation}/${path}`).pipe(
      map(item => this.mapResponse(item, mappingCallback)),
      catchError(GenericOldService.handleError),
    );
  }

  private mapResponse(item, mappingCallback): T {
    if (!item) {
      return item;
    }
    const data = item['data'];
    if (!mappingCallback) {
      if (typeof data !== 'object') {
        return data;
      }
      return resetUUID(toCamel(data)) as T;
    }
    return resetUUID(toCamel(mappingCallback(data))) as T;
  }
}
